import SignedUserProfileSchema from './SignedUserProfile.schema.json';
import DeliveryServiceProfileSchema from './DeliveryServiceProfile.schema.json';

export const SignedUserProfile = SignedUserProfileSchema;
export const DeliveryServiceProfile = DeliveryServiceProfileSchema;
